export default __webpack_public_path__ + "static/ti_Monster_Grey-1b025e3e5be9c4f9303ad5559769a02e.png";